import { render } from "./HorizontalTableLoop.vue?vue&type=template&id=63c250aa&scoped=true"
import script from "./HorizontalTableLoop.vue?vue&type=script&lang=ts"
export * from "./HorizontalTableLoop.vue?vue&type=script&lang=ts"

import "./HorizontalTableLoop.vue?vue&type=style&index=0&id=63c250aa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-63c250aa"

export default script